import React, { createContext, useContext, useState } from 'react';

const LayoutContext = createContext({
  headerContent: null,
  setHeaderContent: () => {},
});

export const useLayout = () => useContext(LayoutContext);

export const LayoutProvider = ({ children }) => {
  const [headerContent, setHeaderContent] = useState(null);

  const value = React.useMemo(() => ({
    headerContent,
    setHeaderContent
  }), [headerContent]);

  return (
    <LayoutContext.Provider value={value}>
      {children}
    </LayoutContext.Provider>
  );
};
